import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { makeStyles } from '@material-ui/core/styles'
import LogProspektDevicePlaceTable from './components/LogProspektDevicePlaceTable'
import LogProspektDeviceTable from './components/LogProspektDeviceTable'
import PropTypes from 'prop-types'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    )
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        width: "-webkit-fill-available"
    },
}))


export default function Employers(props) {
    const {
        chooseProspektId,
        setChooseProspektId,
        setShowLog,
        showLog,
    } = props;

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    const classes = useStyles()
    const [logRowsDevice, setLogRowsDevice] = useState([]);
    const [logRowsDevicePlace, setLogRowsDevicePlace] = useState([]);
    const [isError, setIsError] = useState(false);
    const [sortField, setSortField] = useState("");
    const [orderBy, setOrderBy] = useState(false);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(1000);
    const [logId, setLogId] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);

    const onLogRows = () => {
        setIsLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_API_URL}employee/report/${chooseProspektId}`,

            )
            .then(({ data }) => {
                setIsLoading(false);
                setLogRowsDevice(data[0].deviceNames);
                setLogRowsDevicePlace(data[0].devicePlaceNames)

                setIsError(false);
            })
            .catch((error) => {
                setIsLoading(false);
                setIsError(true);
                setLogRowsDevice([]);
                setLogRowsDevicePlace([])

            });
    };

    useEffect(() => {
        if (showLog) {
            onLogRows(skip, take, sortField, orderBy);
        }
    }, [skip, take, sortField, orderBy, showLog]);







    return (
        <Modal
            show={showLog}
            onHide={setShowLog}
            size="lg"
            aria-labelledby="edit"
            centered
            className="pr-0 ModalSize"
        >
            <Modal.Header closeButton>
                <Modal.Title id="delete">Əməkdaşlar üzrə hesabat qurğu və qurğu məkanı detalları</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row bg-white rounded  mt-6 mb-6">

                    <div className={classes.root}>
                        <AppBar position="static">
                            <Tabs value={value} onChange={handleChange}>
                                <Tab label="Qurğu" />
                                <Tab label="Qurğu məkanı" />
                            </Tabs>
                        </AppBar>
                        {value === 0 && (
                            <TabContainer>
                                <LogProspektDeviceTable
                                    logRows={logRowsDevice}
                                    chooseProspektId={chooseProspektId}
                                    setChooseProspektId={setChooseProspektId}
                                    setSortField={setSortField}
                                    setOrderByTable={setOrderBy}
                                    sortField={sortField}
                                    orderBy={orderBy}
                                    isLoading={isLoading}
                                    isError={isError}
                                    updateSkip={setSkip}
                                    updateTake={setTake}
                                    take={take}
                                    setLogId={setLogId}
                                    logId={logId}
                                />
                            </TabContainer>
                        )}
                        {value === 1 && (
                            <TabContainer>
                                <LogProspektDevicePlaceTable
                                    logRows={logRowsDevicePlace}
                                    chooseProspektId={chooseProspektId}
                                    setChooseProspektId={setChooseProspektId}
                                    setSortField={setSortField}
                                    setOrderByTable={setOrderBy}
                                    sortField={sortField}
                                    orderBy={orderBy}
                                    isLoading={isLoading}
                                    isError={isError}
                                    updateSkip={setSkip}
                                    updateTake={setTake}
                                    take={take}
                                    setLogId={setLogId}
                                    logId={logId}

                                />
                            </TabContainer>
                        )}

                    </div>
                </div>
            </Modal.Body>

        </Modal>
    );
}




